export default __webpack_public_path__ + "svg/logo-w-new.svg?9732a9ec";